import { useEffect } from "react";
import { useLocation } from "react-router";

export const trackButtonClick = (label, category = "Button") => {
  if (window.gtag) {
    window.gtag("event", "button_click", {
      event_category: category,
      event_label: label,
      page_path: window.location.pathname,
    });
  } 
};

export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        if (window.gtag) {
            window.gtag("event", "page_view", {
                page_path: location.pathname + location.search,
            });
        }
    }, [location]);
};

export const trackFormSubmit = (formName) => {
  if (window.gtag) {
    window.gtag("event", "form_submit_success", {
      event_category: "Form",
      event_label: formName,
      page_path: window.location.pathname,
    });
  }
};
